function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   font-size: 12px;\n   display: inline-block;\n   width: 100%;\n   margin-bottom: 0;\n   text-align: center;\n   color: ", ";\n\n   ", " {\n      text-align: right;\n   }\n\n   ", " {\n      text-align: center;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { createBreakpoint } from '../../util/createBreakpoint';
var SiteFooterText = styled.small(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.mediumGray;
}, function (_ref2) {
  var theme = _ref2.theme;
  return createBreakpoint('above', 'md', theme);
}, function (_ref3) {
  var theme = _ref3.theme;
  return createBreakpoint('above', 'lg', theme);
});
export { SiteFooterText };